export var DocumentRenderMode;
(function (DocumentRenderMode) {
    DocumentRenderMode["SVG"] = "svg";
    DocumentRenderMode["CANVAS"] = "canvas";
})(DocumentRenderMode || (DocumentRenderMode = {}));
//# sourceMappingURL=DocumentRenderMode.js.map